import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import packageJson from '../../package.json';
import { ConfigModel } from '@ibe/services';
import TrackingService from './TrackingService';
import { Tenant } from '../Translations';

const GTM_SCRIPT_SRC_BY_TENANT: Record<Tenant, string> = {
  [Tenant.DE]: 'https://t.trendtours.de/gtm.js',
  [Tenant.AT]: 'https://t.trendtours.at/gtm.js',
  [Tenant.CH]: 'https://t.trendtours.ch/gtm.js',
  [Tenant.NL]: 'https://t.trendtours.nl/gtm.js'
};

const getGtmScriptSrc = (tenant?: string | null): string =>
  GTM_SCRIPT_SRC_BY_TENANT[tenant as Tenant] ?? GTM_SCRIPT_SRC_BY_TENANT[Tenant.DE];

const analyticsOptions: {
  app: string;
  version: string;
  debug: boolean;
  plugins: Array<Record<string, unknown>>;
} = {
  app: packageJson.name,
  version: packageJson.version,
  debug: process.env.NODE_ENV !== 'production',
  plugins: []
};

export let tracking = Analytics(analyticsOptions);
export const trackingService = new TrackingService();
export const enableTracking = (config: ConfigModel) => {
  if (config.googleTagManagerContainerId) {
    analyticsOptions.plugins.push(
      googleTagManager({
        containerId: config.googleTagManagerContainerId,
        customScriptSrc: getGtmScriptSrc(config.tenant)
      })
    );
  }

  tracking = Analytics(analyticsOptions);
};
